import { Button, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { addParticipant } from '../AdminMenusRequests'
import toast from 'react-hot-toast'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export const AddParticipant = ({close,setParticipants,setMaleParticipants,setFemaleParticipants,participants}) => {
    const [userInfo,setUserInfo] = useState({
        name:'',
        office:'',
        number:'',
        sex:'MALE'
    })
    useEffect(()=>{
        //get last number of participants
        if(participants.length>0){
            setUserInfo({
                ...userInfo,
                number:participants[participants.length-1].number+1
            })
        }else{
            setUserInfo({
                ...userInfo,
                number:1
            })
        }
    },[])
    const handleChange = (e,name) => {
        setUserInfo({
            ...userInfo,
            [name]:e.target.value
        })
    }
    const handleSave = async (e) => {
        e.preventDefault();
        const toastId = toast.loading('Adding new participant'); 
        const res = await addParticipant(userInfo)
        if(res.data.status === 200){
            setParticipants(res.data.data.data)
            setMaleParticipants(res.data.data.male)
            setFemaleParticipants(res.data.data.female)
            toast.success(res.data.message, {
                id: toastId,
            });
            close();
        }else{
            // toast.dismiss(toastId);
            toast.error(res.data.message, {
                id: toastId,
            });

        }

    }
    return(
        <form onSubmit={handleSave}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField type='text' label ='Name' value={userInfo.name} onChange={(val)=>handleChange(val,'name')} fullWidth required/>
            </Grid>
            <Grid item xs={12}>
                <TextField type='text' label ='Office' value={userInfo.office} onChange={(val)=>handleChange(val,'office')} fullWidth required/>
            </Grid><Grid item xs={12}>
                <TextField type='number' label ='Number' value={userInfo.number} onChange={(val)=>handleChange(val,'number')} fullWidth required InputProps={{readOnly:true}}/>
            </Grid>
            <Grid item xs={12}>
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Sex</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        row
                        value={userInfo.sex}
                        onChange={(val)=>handleChange(val,'sex')}
                    >
                        <FormControlLabel value="MALE" control={<Radio />} label="Male" />
                        <FormControlLabel value="FEMALE" control={<Radio />} label="Female" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{display:'flex',gap:1,justifyContent:'flex-end'}}>
                <Button variant='outlined' color='error' onClick={close}>Cancel</Button>
                <Button variant='contained' color='success' type='submit'>Save</Button>
            </Grid>
        </Grid>
        </form>
    )
}